export default __webpack_public_path__ + "static/media/location.19b447d7.png";